import { useState, useEffect } from 'react';
import { storageHandler } from '@storageHandler';
import FillSessionStorage from '@applicationKYC/LegalEntityQuestionnaire/Utils/answersToSessionStorage';

const INPUT_KEYS = {
  REPEATING_INFORMATION_MANAGER: 'repeating_information_manager',
  MANAGER_EMAIL: 'question_manager_email'
};

const getInputValueFromAnswers = (answers, inputKey) =>
  answers?.find((answer) => answer.inputName === inputKey)?.inputValue;

const updateRepeatingManagerInStorage = (questions) => {
  const answer = questions.find((q) => q.questionKey === INPUT_KEYS.REPEATING_INFORMATION_MANAGER);
  if (answer) {
    FillSessionStorage({
      inputName: INPUT_KEYS.REPEATING_INFORMATION_MANAGER,
      inputValue: answer?.value
    });
  }
};

const useFilteredQuestions = (group) => {
  const [filteredQuestions, setFilteredQuestions] = useState(group.questions);

  const applicationId = storageHandler.getSessionStorage('applicationId');

  useEffect(() => {
    updateRepeatingManagerInStorage(group.questions);
  }, [group.questions]);

  useEffect(() => {
    const answers = storageHandler.getSessionStorage(`answers_${applicationId}`);
    const hideEmail = getInputValueFromAnswers(answers, INPUT_KEYS.REPEATING_INFORMATION_MANAGER);

    const updatedQuestions = group.questions
      .filter((q) => q.questionKey !== INPUT_KEYS.MANAGER_EMAIL || hideEmail === false)
      .map((q) => (q.questionKey === INPUT_KEYS.MANAGER_EMAIL ? { ...q, required: true } : q));

    setFilteredQuestions(updatedQuestions);
  }, [group.questions, applicationId]);

  return filteredQuestions;
};

export default useFilteredQuestions;
